// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3yCh6","row":"ProcedureTreatmentSummary_row__35GlE"};